import { RmaLrpCommodityNames } from '@harvestiq/constants';
import { z } from '@harvestiq/zod';
import { zIsoDate } from '@harvestiq/zod';

export const lrpOptionsRequestSchema = z.object({
  commodity: z.nativeEnum(RmaLrpCommodityNames),
  marketingDate: zIsoDate(),
  optionType: z.string(),
  minCoveragePrice: z.coerce.number(),
  maxCoveragePrice: z.coerce.number(),
});

export type LrpOptionsRequest = z.infer<typeof lrpOptionsRequestSchema>;

export const lrpOptionsResponseSchema = z.object({
  optionData: z.array(z.tuple([z.number(), z.number()])),
});

export type LrpOptionsResponse = z.infer<typeof lrpOptionsResponseSchema>;
